module.exports = __webpack_public_path__ + "static/step3-f5446a398838c44f13de794713b4a561.png";